import apiClient, { API_PREFIX } from './client';

export interface AdminLoginPayload {
  username: string;
  password: string;
}

export interface AdminUserProfile {
  id: string;
  username: string;
  email: string;
  role: 'admin' | 'user';
  permissions: string[];
  lastLoginAt?: string | null;
  requirePasswordChange?: boolean;
}

export interface AdminLoginResponse {
  token: string;
  expiresIn: number;
  idleTimeoutMinutes: number;
  user: AdminUserProfile;
}

export async function loginAdmin(payload: AdminLoginPayload): Promise<AdminLoginResponse> {
  const response = await apiClient.post<AdminLoginResponse>(`${API_PREFIX}/admin/auth/login`, payload);
  return response.data;
}

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export async function changeAdminPassword(payload: ChangePasswordPayload): Promise<void> {
  await apiClient.post(`${API_PREFIX}/admin/auth/change-password`, payload);
}

export interface ForceChangePasswordPayload {
  username: string;
  currentPassword: string;
  newPassword: string;
}

export async function forceChangeFirstPassword(payload: ForceChangePasswordPayload): Promise<void> {
  await apiClient.post(`${API_PREFIX}/admin/auth/force-change-password`, payload);
}
